import ModalTrigger from './ModalTrigger.vue'

export default ModalTrigger
